import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "../helper";
import { Guid } from "guid-typescript";
import { IVendorDTO, VendorModel } from "../models/vendor/vendorDTO";
let VendorsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    let VendorsModule = class VendorsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "vendor";
            this.venders = [];
            this.venderDetails = null;
            this.vendor = null;
        }
        async GetVendorListings() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetVendorListing(plainToClass(VendorModel, data.vendors));
                return data;
            }
        }
        SetVendorListing(vendor) {
            this.venders = vendor;
        }
        async CreateVendor(vender) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, vender);
            if (data) {
                return data;
            }
        }
        async GetVendorDetailById(vendorId) {
            var url = `${getTenantId()}/${this.apiNode}/${vendorId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetVenderDetail(plainToClass(VendorModel, data.vendor));
                return data;
            }
        }
        SetVenderDetail(vender) {
            this.venderDetails = vender;
        }
        async UpdateVender(vender) {
            var url = `${getTenantId()}/${this.apiNode}/update-vender`;
            let { data } = await service.put(url, vender);
            if (data) {
                return data;
            }
        }
        //Delete
        async DeleteVendor(deleteId) {
            var url = `${getTenantId()}/${this.apiNode}/` + "DeleteVendor/" + deleteId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        //View
        async ViewVendor(vendorId) {
            var url = `${getTenantId()}/${this.apiNode}/` + vendorId;
            let { data } = await service.get(url);
            if (data) {
                this.ViewVendors(plainToClass(VendorModel, data.vendor));
                return data;
            }
        }
        //Mutations
        ViewVendors(vendor) {
            this.vendor = vendor;
        }
        async DeleteVendorById(vendorId) {
            var url = `${getTenantId()}/${this.apiNode}/` + vendorId + "/deleteVendor";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], VendorsModule.prototype, "GetVendorListings", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], VendorsModule.prototype, "SetVendorListing", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof IVendorDTO !== "undefined" && IVendorDTO) === "function" ? _b : Object]),
        __metadata("design:returntype", Promise)
    ], VendorsModule.prototype, "CreateVendor", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], VendorsModule.prototype, "GetVendorDetailById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof IVendorDTO !== "undefined" && IVendorDTO) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], VendorsModule.prototype, "SetVenderDetail", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof VendorModel !== "undefined" && VendorModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], VendorsModule.prototype, "UpdateVender", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof Guid !== "undefined" && Guid) === "function" ? _g : Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], VendorsModule.prototype, "DeleteVendor", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], VendorsModule.prototype, "ViewVendor", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof VendorModel !== "undefined" && VendorModel) === "function" ? _k : Object]),
        __metadata("design:returntype", void 0)
    ], VendorsModule.prototype, "ViewVendors", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof Guid !== "undefined" && Guid) === "function" ? _l : Object]),
        __metadata("design:returntype", Promise)
    ], VendorsModule.prototype, "DeleteVendorById", null);
    VendorsModule = __decorate([
        Module({ dynamic: true, store: store, name: "vender", namespaced: true })
    ], VendorsModule);
    return VendorsModule;
})();
export const VendorModule = getModule(VendorsModule);
